<div id="app-reset-wrapper" [ngSwitch]="hostname">
  <div *ngSwitchDefault id="app-reset-wrapper-default">
    <app-index-layout [layoutData]="layoutData">
      <div box-body>
        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>New Password</mat-label>
              <input [type]="hide ? 'password' : 'text'" matInput formControlName="newPassword" />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hide = !hide"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide"
              >
                <mat-icon class="green-icon">{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
              <mat-error *ngIf="resetPasswordForm.hasError('required', 'newPassword')">
                New password is <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="resetPasswordForm.hasError('minLength', 'newPassword')">
                Password is <strong>too short</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>Re-enter New Password</mat-label>
              <input [type]="hideConfirm ? 'password' : 'text'" matInput formControlName="confirmPassword" />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hideConfirm = !hideConfirm"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideConfirm"
              >
                <mat-icon class="green-icon">{{ hideConfirm ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
              <mat-error *ngIf="resetPasswordForm.hasError('required', 'confirmPassword')">
                Password confirmation is <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="resetPasswordForm.hasError('notSame', 'confirmPassword')">
                Passwords does not match
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-group buttons text-center">
            <button type="submit" [disabled]="!resetPasswordForm.valid" class="btn btn-primary">Send</button>
          </div>
        </form>
      </div>
    </app-index-layout>
  </div>
  <div
    *ngSwitchCase="environment.relutechUrl"
    id="app-reset-wrapper-relutech"
    class="row d-flex justify-content-center"
  >
    <div class="container-fluid text-center d-flex justify-content-center">
      <div class="row h-100">
        <div id="app-reset-section-one" class="app-reset-section col-md">
          <div class="d-flex flex-column justify-content-center h-100">
            <h1 class="text-light">Welcome to the</h1>
            <img class="" src="../../../assets/login/relutech/RAMP%20Logo-01.png" alt="..." />
            <h1 class="text-light">Powered by ReluTech, LLC.</h1>
          </div>
        </div>

        <div id="app-reset-section-two" class="app-reset-section col-md">
          <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <div class="form-column">
              <div class="form-header pb-3">
                <h1>Reset Password</h1>
              </div>
              <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                <div class="form-group mb-5">
                  <label class="input-label-relutech">New Password *</label>
                  <input
                    type="password"
                    formControlName="newPassword"
                    class="form-control"
                    autocomplete="newPassword"
                    [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }"
                  />
                  <div *ngIf="submitted && !!f.newPassword.errors" class="invalid-feedback">
                    <div *ngIf="!!f.newPassword.errors?.required">New Password is required</div>
                    <div *ngIf="!!f.newPassword.errors?.minlength">New Password must be at least 5 characters</div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="input-label-relutech">Re-enter New Password *</label>
                  <input
                    type="password"
                    formControlName="confirmPassword"
                    class="form-control"
                    autocomplete="confirmPassword"
                    [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }"
                  />
                  <div *ngIf="submitted && !!f.confirmPassword.errors" class="invalid-feedback">
                    <div *ngIf="!!f.confirmPassword.errors?.required">New Password is required</div>
                    <div *ngIf="!!f.confirmPassword.errors?.notSame">Passwords does not match</div>
                  </div>
                </div>
                <div class="form-group-buttons text-center d-flex justify-content-end align-items-end flex-column">
                  <button type="submit" class="btn btn-primary btn-relutech">Send</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
